<h2>Page Sections and Containers</h2>

<div style="margin-bottom: 20px">
  <table>
    <tr>
      <td>
        <div class="sectionContainer paddedContent containerMargins">
          <div style="height: 150px">
            Here's some stuff that goes in its own container.
          </div>

          There's more down here.
        </div>
      </td>
      <td>
        <textarea codeSnippet>
                    <div class="sectionContainer paddedContent containerMargins">

                        <div style="height:150px;">
                            Here's some stuff that goes in its own container.
                        </div>
        
                        There's more down here.
        
                    </div>                
                </textarea
        >
      </td>
    </tr>
    <tr>
      <td>
        <div class="sectionContainer containerMargins">
          <div style="height: 150px">
            You can also remove the padding and manage it yourself it you need
            to.
          </div>

          Just don't apply the <i>paddedContent</i> class.
        </div>
      </td>
      <td>
        <textarea codeSnippet>
                    <div class="sectionContainer containerMargins">

                        <div style="height:150px;">
                            You can also remove the padding and manage it yourself it you need to.
                        </div>
        
                        Just don't apply the <i>paddedContent</i> class.
        
                    </div>
                </textarea
        >
      </td>
    </tr>
  </table>
</div>

<div>
  <b>Code-Snippets</b>

  <p>
    Use the codeSnippet directive on a &lt;textarea&gt; to render code-style.
  </p>

  <p>
    Line breaks are preserved, but leading and trailing whitespace will be
    truncated.
  </p>

  <table>
    <tr>
      <td>
        <textarea codeSnippet>
                    Apply the codeSnippet attribute to a textarea to render its contents
                    as code.

                        You can even do tabbed indents!

                    HTML works, too! <input type="button" />
                    <!--
                    So do comments!
                    -->
                    // also these!

                    /* and these! */
                </textarea
        >
      </td>
      <td>
        <textarea codeSnippet>
                    &lt;textarea codeSnippet>
                    Apply the codeSnippet attribute to a textarea to render its contents
                    as code.

                        You can even do tabbed indents!

                    HTML works, too! <input type="button" />
                    <!--
                    So do comments!
                    -->
                    // also these!

                    /* and these! */
                    &lt;/textarea>
                </textarea
        >
      </td>
    </tr>
  </table>
</div>
